export default "__VITE_ASSET__d2a3577a__"